// extracted by mini-css-extract-plugin
export var container = "NewsLinkTemplate-module--container--kc5KT";
export var image = "NewsLinkTemplate-module--image--kWxUA";
export var date = "NewsLinkTemplate-module--date--aYnmr";